export const CHECKOUT_PERMISSION_ENUM = {
  CHEKOUT_CREATE: 'shop.checkout:create'
}

export const isCheckoutCreateAllowed = (permissionIsEnabledFn) => {
  return permissionIsEnabledFn(CHECKOUT_PERMISSION_ENUM.CHEKOUT_CREATE)
}
